export function debounce<T extends unknown[]>(
    delay: number,
    fn: (...params: T) => void,
): ((...args: T) => void) & { cancel: () => void } {
    let timerId: ReturnType<typeof setTimeout> | null;
    const debouncedFn = function (...args: T) {
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
            fn(...args);
            timerId = null;
        }, delay);
    };

    debouncedFn.cancel = () => {
        if (timerId) {
            clearTimeout(timerId);
            timerId = null;
        }
    };

    return debouncedFn;
}
